import { useEffect, useState } from 'react';

export default function useLocalStorage(key, initialValue, override = false) {
  const [storedValue, setStoredValue] = useState(() => {
    if (override) return initialValue;
    try {
      const item = key ? window.localStorage.getItem(key) : null;
      if (!item && key) window.localStorage.setItem(key, JSON.stringify(initialValue));
      return item ? JSON.parse(item) : initialValue;
    } catch (e) {
      return initialValue;
    }
  });

  useEffect(() => {
    if (!key) return;
    const handler = () => {
      const item = window.localStorage.getItem(key);
      if (item) setStoredValue(JSON.parse(item));
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, [key]);

  const setValue = (value) => {
    const valueToStore = value instanceof Function ? value(storedValue) : value;
    setStoredValue(valueToStore);
    if (key) window.localStorage.setItem(key, JSON.stringify(valueToStore));
  };

  return [storedValue, setValue];
}
